import * as actionTypes from '../actions/actionTypes'
const initState = {
  response: [],
  message: '',
}

export default (state = initState, action={}) => {
  switch (action.type) {
    case actionTypes.NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        type:'list',
        response: [],
        message: '',      
      }   
    case actionTypes.NOTIFICATION_LIST_SUCCESS:
        
      return {
        ...state,
        type:'list',
        response: action.payload.data,
        message: 'Success',      
      }   
    case actionTypes.NOTIFICATION_LIST_ERROR:
    
      return {
        ...state,
        type:'list',
        response: action.payload.response.data,
        message: 'Error',      
      }
    case actionTypes.NOTIFICATION_UNREAD_LIST_REQUEST:
      return {
        ...state,
        type:'unreadCount',
        response: [],
        message: '',      
      }   
    case actionTypes.NOTIFICATION_UNREAD_LIST_SUCCESS:
        
      return {
        ...state,
        type:'unreadCount',
        response: action.payload.data,
        message: 'Success',      
      }   
    case actionTypes.NOTIFICATION_UNREAD_LIST_ERROR:
    
      return {
        ...state,
        type:'unreadCount',
        response: action.payload.response.data,
        message: 'Error',      
      }
    case actionTypes.NOTIFICATION_STATUS_CHANGE_REQUEST:
      return {
        ...state,
        type:'statusChnage',
        response: [],
        message: '',      
      }   
    case actionTypes.NOTIFICATION_STATUS_CHANGE_SUCCESS:
        
      return {
        ...state,
        type:'statusChnage',
        response: action.payload.data,
        message: 'Success',      
      }   
    case actionTypes.NOTIFICATION_STATUS_CHANGE_ERROR:
    
      return {
        ...state,
        type:'statusChnage',
        response: action.payload.response.data,
        message: 'Error',      
      }             
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Notification.js